import { redirect } from '@tanstack/react-router'
import { hasActiveSession } from '@/features/auth/stores/auth-session-store'

type RouterLocationLike = {
  href?: string
  pathname?: string
  searchStr?: string
  search?: string
  hash?: string
}

export function normalizeReturnUrl(value: string | null | undefined): string {
  if (!value || !value.startsWith('/') || value.startsWith('//')) {
    return '/app'
  }

  return value
}

export function getLocationReturnUrl(location?: RouterLocationLike): string {
  if (!location) return '/app'

  if (typeof location.href === 'string' && location.href.startsWith('/')) {
    return normalizeReturnUrl(location.href)
  }

  const pathname = typeof location.pathname === 'string' ? location.pathname : '/app'
  const search = typeof location.searchStr === 'string' ? location.searchStr : ''
  const hash = typeof location.hash === 'string' ? location.hash : ''
  return normalizeReturnUrl(`${pathname}${search}${hash}`)
}

export function requireAuthBeforeLoad({ location }: { location: any }) {
  if (hasActiveSession()) {
    return
  }

  throw redirect({
    to: '/login',
    search: {
      redirect: getLocationReturnUrl(location),
    },
  })
}